import { DialogLoadLazyProps, DialogPagePlusProps } from "@/componentsUI/Dialog/dialogPlus";

let dialogRef = null;
export const setDialogRef = (ref)=>{
  dialogRef = ref
}

interface DialogReturnRef {

  push: (params: DialogPagePlusProps) => void,
  pop: () => void,
  closeAll: () => void,
  replace: (path: any, params: DialogLoadLazyProps) => void;

  /**关闭所有界面 */
  close: () => void,

  pushLoadLazy: (path: any, params: DialogLoadLazyProps) => void;
}

function useDialog(): DialogReturnRef {
  const pop = () => {
    dialogRef?.current?.pop()
  }
  const push = (params: DialogPagePlusProps) => {
    console.log('push', params)
    dialogRef?.current?.push(params)
  }
  const closeAll = () => {
    dialogRef?.current?.closeAll()
  }

  const replace = (path: any, params: DialogLoadLazyProps)=>{
    dialogRef?.current?.replace(path,params)
  }

  const close = () => {
    dialogRef?.current?.closeAll()
  }

  const pushLoadLazy = (path:any,params: DialogLoadLazyProps)=>{
    dialogRef?.current?.pushLoadLazy(path,params)
  }


  return {
    pop,
    push,
    closeAll,
    replace,
    close,
    pushLoadLazy
  }
}

export default useDialog;
